// Carry Roll localStorage persistence adapter — thin wrapper over Zustand persist.

export interface PersistStorage {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
}

/**
 * Safe localStorage adapter. Quota/serialization errors are thrown so the store
 * can surface an error toast (PSD §10.8).
 */
export const localStorageAdapter: PersistStorage = {
  getItem(key) {
    try {
      return globalThis.localStorage?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      globalThis.localStorage?.setItem(key, value);
    } catch (err) {
      throw new Error(`Couldn't save — storage full. Export and clear old sessions.`);
    }
  },
  removeItem(key) {
    try {
      globalThis.localStorage?.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};

export const SETTINGS_KEY = 'carry-roll.settings';
export const INPUT_KEY = 'carry-roll.input';
